<template>
	<EventSlider :events="alternatives"></EventSlider>
</template>

<script lang="ts" setup>


import {CartEventInterface} from "@/js/interfaces/event"
import EventSlider from "@/js/components/elements/EventSlider.vue"

withDefaults(defineProps<{
	event: CartEventInterface
	alternatives: CartEventInterface[];
	isUpsells?: boolean
}>(), {
	isUpsells: false
})
</script>

<style scoped>

</style>
